<template>
  <div class="sticker-setting-container">
    <div class="sticker-item-view">
      <div class="sticker-footer">
        <!--   스키터 종류 v-for   -->
        <div class="sticker-sort-list">
          <button v-for="item in stickerList" class="sticker-footer-item" :class="{inactive: selectedSticker !== item.id}" :key="item.id" :value="item.id" @click="changeStickers" :style="{'background-image': 'url(' + cdnImgUrl(item.imagePath?.replace('.svg', '_active.svg')) + ')'}"></button>
        </div>
        <div class="sticker-control-container">
<!--          <button v-if="!isDevicetest" class="save-sticker" @click="onSaveCoordi"></button>-->
          <button class="reset-sticker" @click="resetStickerItem"></button>
        </div>
      </div>
      <ul v-if="selectedSticker" class="sticker-item-list" :class="{'device-coordi': isDevicetest}">
        <!--  sticker 리스트 v-for      -->
<!--        <li>-->
<!--          <div class="reset-sticker" @click="resetStickerItem">스티커 초기화</div>-->
<!--        </li>-->
        <li v-for="item in stickerItems[selectedSticker]" :key="item.id" @click="selectItem(item)" :style="{'background-image': 'url(' + cdnImgUrl(item.imagePath) + ')'}"></li>
      </ul>
      <div v-else class="sticker-item-list">
        <div class="w-full sticker-none flex items-center justify-center text-white flex-col">
          <div class="none-message">
            {{$t('camstudy.stopwatch.noItem')}}
          </div>
          <button @click="onClickStickerPage">구매하기</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {cdnImgUrl} from "@/utils/ImageUrl";

export default {
  name: "Sticker",
  props: {
    isDevicetest: Boolean,
    roomInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    userProfile: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data(){
    return {
      userStickerList: [],
      copyUserStickerList: [],
      purchasedStickerList: [],
      notOrderedStickerList: [],

      chooseStickerList: [],
      stickerListKeyValue: {},

      clickedStickerType: '',

      orderStickerIndex: 0,
      notOrderStickerIndex: 0,

      orderedStickerName: '',
      notOrderStickerName: '',

      selected: '',
      selectedSticker: null,
    }
  },
  async created() {
    await this.loadUserStickerItemList();
    await this.loadStickerItemList();
    await this.loadPurchasedStickerList();
    this.copyUserStickerList = this.userStickerList;

    if (this.userStickerList.length) {
      await this.setClickedUserSticker(this.userStickerList[0].id, this.userStickerList[0].item.id)
    } else if(this.notOrderedStickerList.length) {
      this.setNotOrderSticker(this.notOrderedStickerList[0].item.id, this.notOrderedStickerList[this.notOrderStickerIndex].name)
    }

    await this.getStickerList('STICKER')

    if(!this.selectedSticker){
      const find = this.purchasedStickerList.find((v) => v.id === this.stickerList[0]?.id);
      if(!this.isPremiumRoom){
        if(find) {
          this.selectedSticker = this.stickerList.find((v) => v.id === 'itemid1').id
        }
        return
      }
      if(find) {
        this.selectedSticker = this.stickerList[0]?.id
      }
    }
  },
  computed: {
    ...mapGetters('coordi', [
        'stickerList',
        'stickerItems'
    ]),
    ...mapGetters('room',[
      'isPremiumRoom'
    ]),
  },
  watch: {
    async selectedSticker() {
      if(this.selectedSticker === null){
        return;
      }
      await this.getStickerItem(this.selectedSticker);
    },
    stickerList() {
      if(!this.selectedSticker){
        const find = this.purchasedStickerList.find((v) => v.id === this.stickerList[0]?.id);
        if(!this.isPremiumRoom){
          if(find) {
            this.selectedSticker = this.stickerList.find((v) => v.id === 'itemid1').id
          }
          return
        }
        if(find) {
          this.selectedSticker = this.stickerList[0]?.id
        }
      }
    },
  },
  methods: {
    cdnImgUrl,
    ...mapActions('camstudy', [
      'getCamStudyUserProfile',
    ]),
    ...mapActions('coordi', [
        'getStickerList',
        'getStickerItem',
        'getUserStickerList',
        'getPurchaseStickerList'
    ]),
    resetStickerItem() {
      this.$parent.resetUserSticker();
    },
    async stickerChange(path){
      const data = cdnImgUrl(path)
      console.log(data);
      return data;
    },
    selectItem(item){
      this.$parent.selectSticker(item);
    },
    async setClickedUserSticker(stickerId, itemId) {
      this.chooseStickerList = await this.getStickerList(itemId)
      this.selected = itemId;
      this.clickedStickerType = 'ORDERED';
    },
    setNotOrderSticker(itemId, name) {
      this.notOrderStickerName = name;
      this.selected = itemId;
      this.clickedStickerType = 'NOT_ORDERED';
    },
    async loadUserStickerItemList() {
      // this.userStickerList = await userItemApi.userItemListByCategory(this.category);
    },
    async loadPurchasedStickerList() {
      this.purchasedStickerList = await this.getPurchaseStickerList();
    },
    async loadStickerItemList() {
      this.notOrderedStickerList = [];
      // let res = await itemApi.itemListByCategory(this.category);
      // let THIS = this;
      // res.forEach(sticker => {
      //   !THIS.existInOrderedList(sticker) && THIS.notOrderedStickerList.push(sticker);
      // })
    },
    existInOrderedList(item) {
      for (let stickerItem of this.userStickerList) {
        if (stickerItem.item.id === item.id) {
          return true;
        }
      }
      return false;
    },
    // async getStickerList(itemId) {
    //   // if (!this.stickerListKeyValue[itemId]) {
    //   //   this.stickerListKeyValue[itemId] = await itemApi.stickerListByItemId(itemId);
    //   // }
    //   // return this.stickerListKeyValue[itemId];
    // },
    // 스티커 선택 했을 떄 이벤트
    async clickEvent(type, index) {
      if (type === 'ORDERED') {
        await this.setClickedUserSticker(this.userStickerList[index].id, this.userStickerList[index].item.id)
      } else {
        this.notOrderStickerIndex = index;
        this.setNotOrderSticker(this.notOrderedStickerList[index].id, this.notOrderedStickerList[index].name)
      }
    },
    changeStickers(e){
      const find = this.purchasedStickerList.find((v) => v.id === e.target.value);
      if(!find){
        this.selectedSticker = null;
        return
      }
      this.selectedSticker = e.target.value;
    },
    onSaveCoordi(){
      this.$emit('saveCoordi', 'sticker')
    },
    onClickStickerPage(){
      this.$camsAlert({
        title: this.$t('camstudy.stopwatch.noItem'),
        text: this.$t('camstudy.stopwatch.shopText'),
        okText: this.$t('camstudy.stopwatch.move'),
        ok: () => {
          const env = process.env.NODE_ENV;
          if(env === 'development') {
            window.open('https://cams-dev.gooroomee.com/camstudy/shop', '_blank');
          }else if(env === 'production') {
            window.open('https://gooroomee.com/camstudy/shop', '_blank');
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
[grm-device-mobile]{
  .sticker-item-list{
    @media(orientation: portrait) {
      height: calc(100dvh - 64px - 100dvw - 80px);
      padding-bottom: 10px;
      &.device-coordi{
        height: calc(100dvh - 100px - 100vw - 100px);
      }
    }
    @media(orientation: landscape) {
      height: calc(100dvh - 184px);
      &.device-coordi{
        height: calc(100dvh - 234px);
      }
    }
  }
}
html:not([grm-device-mobile]){
  .sticker-item-view{
    max-height: 278px;
  }
  .sticker-item-list{
    height: 100%;
    &.device-coordi{
      max-height: 232px;
    }
    &:not(.device-coordi){
      li{
        width: calc((100% - 30px) / 3);
      }
    }
    &::-webkit-scrollbar{
      display: none;
    }
  }
}
.sticker-setting-container{
  width: 100%;
  border-radius: 6px 6px 0 0;
  animation: bottomUp 0.5s forwards;
  
  .sticker-item-view {
    width: 100%;
    height: 100%;
  }

  .sticker-item-list{
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    overflow-y: scroll;

    li{
      width: calc((100% - 30px)/4);
      aspect-ratio : 1 / 1;
      border-radius: 6px;
      flex-shrink: 0;
      background: #393939 center no-repeat;
      background-size: auto 60px;
    }
  }
  //.reset-sticker{
  //  color: #FFF;
  //  text-align: center;
  //  font-size: 12px;
  //  font-weight: 700;
  //  line-height: 150%;
  //  padding-top: 77.33px;
  //  opacity: 0.2;
  //  background: url("~@/assets/images/camstudy/ico_resetSticker_white.svg") no-repeat top 21.33px center;
  //}
  .sticker-footer{
    height: 36px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    margin-bottom: 10px;

    .sticker-sort-list{
      display: flex;
      gap: 12px;
    }
    .sticker-control-container{
      display: flex;
      padding-left: 12px;
      border-left: 1px solid #393939;
    }

    .sticker-footer-item{
      width: 36px;
      height: 36px;
      // background: white;
      border-radius: 50%;

      &.inactive{
        filter: grayscale(100%);
        -webkit-filter: grayscale(100%);
      }
    }
  }
  .reset-sticker{
    background: url('~@/assets/images/camstudy/ico_resetSticker_white.svg') no-repeat center center;
    width: 32px;
    height: 32px;
  }
  .save-sticker{
    background: url('~@/assets/images/camstudy/ico_saveSticker_white.svg') no-repeat center center;
    width: 32px;
    height: 32px;
  }
}
@keyframes bottomUp {
  0%{
    bottom: -100%;
  }
  100%{
    bottom: 0;
  }
}
.sticker-none{
  height: 232px;

  button{
    padding: 10px 24px;
    background-color: #016FF2;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 500;
  }
}
.none-message{
  margin-bottom: 14px;
  font-size: 14px;
  font-weight: bold;
}
</style>